import script from "./SelectionProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionProperties.vue?vue&type=script&setup=true&lang=js"

import "./SelectionProperties.vue?vue&type=style&index=0&id=71d0343f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d0343f"]])

export default __exports__